// extracted by mini-css-extract-plugin
export default {"slider-component":"Slider_slider-component__1aV_h","slider-label":"Slider_slider-label__kDUZR"};